import { businessPlanOptions } from 'constants/businessPlan';

import { IBusinessPlanButtonOption, IBusinessPlanType } from 'interfaces/businessPlan';

import { getDocumentType } from 'helpers/getDocumentType';

export const getBusinessPlanIconByType = (type: IBusinessPlanType) =>
  businessPlanOptions.find(({ template }) => getDocumentType(template) === getDocumentType(type));

export const getDocumentColorVariables = (businessPlanOption?: IBusinessPlanButtonOption) => {
  return {
    '--plan-color': businessPlanOption?.color,
    '--plan-background': businessPlanOption?.backgroundColor,
    '--plan-borderColor': businessPlanOption?.borderColor,
  } as React.CSSProperties;
};

export const getBusinessPlanIconDetailsByType = (type: IBusinessPlanType) => {
  const businessPlanOption = getBusinessPlanIconByType(type);
  const cssVariables = getDocumentColorVariables(businessPlanOption);
  const icon = businessPlanOption?.icon;

  return { businessPlanOption, cssVariables, icon };
};
